export default __webpack_public_path__ + "static/media/nax.a76a43ef.jpg";